import React, { FC } from 'react'

import cn from 'classnames'

import { content } from './plan-additional-info.content'
import classes from './plan-additional-info.module.scss'
import Checkmark from '../../static/images/checkmark.svg'
import { ChecklistItem } from '../shared'

interface PlanAdditionalInfoProps {
  dataDiscount?: string
  direction?: 'column' | 'row'
}

export const PlanAdditionalInfo: FC<PlanAdditionalInfoProps> = ({
  dataDiscount,
  direction = 'column',
}) => (
  <div
    id="additional-info"
    className={cn(
      classes.container,
      direction === 'row' && classes.containerRow
    )}
  >
    <ChecklistItem fontSize="0.85rem" color="#444">
      <img
        src={Checkmark}
        alt={content.checkmarkAlt}
        loading="lazy"
        decoding="async"
      />
      {content.dataDiscountPrefix} {dataDiscount} {content.dataDiscountSuffix}
    </ChecklistItem>
    <ChecklistItem fontSize="0.85rem" color="#444">
      <img
        src={Checkmark}
        alt={content.checkmarkAlt}
        loading="lazy"
        decoding="async"
      />
      {content.cancelAnytime}
    </ChecklistItem>
    <ChecklistItem fontSize="0.85rem" color="#444">
      <img
        src={Checkmark}
        alt={content.checkmarkAlt}
        loading="lazy"
        decoding="async"
      />
      {content.noCreditCheck}
    </ChecklistItem>
    <ChecklistItem fontSize="0.85rem" color="#444">
      <img
        src={Checkmark}
        alt={content.checkmarkAlt}
        loading="lazy"
        decoding="async"
      />
      {content.fastData}
    </ChecklistItem>
    <ChecklistItem fontSize="0.85rem" color="#444">
      <img
        src={Checkmark}
        alt={content.checkmarkAlt}
        loading="lazy"
        decoding="async"
      />
      {content.tethering}
    </ChecklistItem>
    <ChecklistItem fontSize="0.85rem" color="#444">
      <img
        src={Checkmark}
        alt={content.checkmarkAlt}
        loading="lazy"
        decoding="async"
      />
      {content.unlimitedCallsTexts}
    </ChecklistItem>
  </div>
)
